module.exports = __webpack_public_path__ + "static/media/head-logo.b7dfcea4.png";